export const baseUrl = 'https://api.eatplek.com/';
export const API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdXRob3JpemVkIjp0cnVlLCJleHAiOjE2NjQwMTI5Nzh9.pI4psQgtsUggwgvCH1dflZ7v5MyUPs8rRenJjZfc6l8';
